import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.PageContent.RequestUploadPlaceholder', {
    filesDragMessage: 'Drag & drop to upload as files',
    filesToSupplieDragMessage: 'Drag & drop to upload as attachments to supplier',
});
